/*
 * Copyright (C) 2005 - 2019 TIBCO Software Inc. All rights reserved. Confidentiality & Proprietary.
 * Licensed pursuant to commercial TIBCO End User License Agreement.
 */

import jrsConfigs from 'js-sdk/src/jrs.configs';
import logger from "js-sdk/src/common/logging/logger";
import settingsLoader from 'jrs-ui/src/settings/settingsLoader';
import bundleLoader from 'jrs-ui/src/i18n/bundleLoader';

const log = logger.register("visualizeSettingsLoader");

const getAdditionalHeaders = (effectiveLocale, effectiveTimezone) => {
    // Set locale and timezone before call to visualizeSettings
    return {
        ...(effectiveLocale ? {'Accept-Language': effectiveLocale.replace(/_/g, '-')} : {}),
        ...(effectiveTimezone ? {'Accept-Timezone': effectiveTimezone} : {})
    };
}

const visualizeSettingsLoader = (properties) => {
    // Set locale and timezone before call to visualizeSettings
    const effectiveLocale = properties.auth && properties.auth.locale ? properties.auth.locale : properties.userLocale;
    const effectiveTimezone = properties.auth && properties.auth.timezone ? properties.auth.timezone : properties.userTimezone;
    const additionalHeaders = getAdditionalHeaders(effectiveLocale, effectiveTimezone);

    return settingsLoader(['visualizeSettings'], properties.server, additionalHeaders).then(([settings]) => {
        log.debug("Server settings: ", settings);

        // pass settings to jrsConfigs for compatibility
        // with old code
        Object.assign(jrsConfigs, {
            contextPath: properties.server,
            availableLocales: settings.availableLocales,
            userLocale: effectiveLocale || settings.userLocale,
            userTimezone: effectiveTimezone || settings.userTimezone,
            localeSettings: settings.localeSettings,
            xssNonce: settings.xssNonce
        });

        return {
            ...settings,
            ...properties,
            theme: properties.useTheme === undefined || properties.useTheme === true
                ? {
                    href: properties.theme && properties.theme.href ? properties.theme.href : `${properties.server}/${settings.themePrefix}`
                }
                : null
        };
    });
}

export default (properties) => {
    return visualizeSettingsLoader(properties).then((enhancedProperties) => {
        // bundles and settings should be loaded after initial viz settings
        // because they need userLocale and userTimezone
        return Promise.all([
            bundleLoader([
                'ScalableInputControlsBundle',
                'RepositoryResourceBundle',
                'AdHocBundle',
                'DashboardBundle',
                'jasperserver_messages',
                'jasperreports_messages',
                'CommonBundle',
                'InputControlsValidation',
                'adhoc_messages',
                'all'
            ], properties.server),
            settingsLoader([
                'auth',
                'dateTimeSettings',
                'decimalFormatSymbols',
                'treeComponent'
            ], properties.server)
        ]).then(() => {
            return enhancedProperties;
        })
    });
}